<div class="customer-short-actions">

    @if (customer().liked) {
        <div class="customer-short-actions-item" [class.customer-short-actions-item--new]="customer().hasNewLikedListings"
            [title]="customer().liked +('CUSTOMER_SHORT_INFO_CARD.TITLES.LIKED' | translate)">

            <pnyc-icon class="customer-short-actions-item-icon" [iconName]="'heart'">
            </pnyc-icon>

            <div class="customer-short-actions-item-text">{{customer().liked}}</div>

        </div>
    }


    @if (customer().newMatches) {
        <div class="customer-short-actions-item"
            [title]="customer().newMatches +('CUSTOMER_SHORT_INFO_CARD.TITLES.NM' | translate)">

            <pnyc-icon class="customer-short-actions-item-icon" [iconName]="'star'">
            </pnyc-icon>

            <div class="customer-short-actions-item-text">{{customer().newMatches}}</div>

        </div>
    }

    @if (customer().messages) {
        <div class="customer-short-actions-item" [class.customer-short-actions-item--new]="customer().newMessages"
            [title]="(customer().messages ?? 0) + ('CUSTOMER_SHORT_INFO_CARD.TITLES.MESSAGES' | translate)">

            <pnyc-icon class="customer-short-actions-item-icon" [iconName]="'message-circle'">
            </pnyc-icon>

            <div class="customer-short-actions-item-text">{{ customer().messages }}</div>

        </div>
    }

    @if (customer().appointments) {
        <div class="customer-short-actions-item" [class.customer-short-actions-item--new]="customer().newAppointments"
            [title]="(customer().appointments ?? 0) + ('CUSTOMER_SHORT_INFO_CARD.TITLES.APPOINTMENTS' | translate)">


            <pnyc-icon class="customer-short-actions-item-icon" [iconName]="'calendar'">
            </pnyc-icon>

            <div class="customer-short-actions-item-text">{{ customer().appointments }}</div>

        </div>
    }

</div>